function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import ReactConfigContext from '../../ReactConfigContext';
import { Body, Heading } from '../../atoms';
import { ELegacySimulatorRegion } from './StepContent/StepRegion';
var LegacySimulatorHeader = function LegacySimulatorHeader(param) {
    var t = param.t, data = param.data;
    var icon = data.icon, description = data.description, title = data.title, stepIndex = data.stepIndex, region = data.region;
    var _useContext = useContext(ReactConfigContext), ImageComponent = _useContext.config.ImageComponent;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-col items-center justify-center w-full h-auto gap-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-center w-20 h-20 p-5 bg-yellow-700 rounded-full"
    }, icon && /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, icon), {
        className: "object-contain"
    }))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "font-semibold font-heading"
    }, stepIndex && "".concat(t('question'), " ").concat(stepIndex, "/4"))), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title)), !!description && region !== ELegacySimulatorRegion.FLANDRE && /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Body, {
        variant: "sm",
        className: "prose"
    }, description)));
};
export default LegacySimulatorHeader;

//# sourceMappingURL=LegacySimulatorHeader.js.map